import React from "react";
const ContactHero = () => <section>hey i'm ContactHero</section>;
export default ContactHero;
